import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { withTranslation } from "react-i18next";

function Modal({
  isOpen,
  handleClose,
  children,
  title,
  headerText,
  className,
  t,
  // eslint-disable-next-line no-unused-vars, react/prop-types
  tReady,
  ...props
}) {
  return (
    <div>
      <Dialog
        open={isOpen}
        fullWidth
        onClose={(_, reason) => {
          if (reason !== "backdropClick") handleClose();
        }}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        {...props}
      >
        <DialogTitle
          id="alert-dialog-title"
          className="border-bottom"
          sx={{ padding: "5px 5px 0" }}
        >
          <div className="text-center d-flex justify-content-between align-items-center p-3">
            <h3 className="semibold-font mb-0">{t(title)}</h3>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          {headerText && (
            <Typography
              variant="h6"
              className="regular-font modal-header-text text-center"
            >
              {headerText}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent className={className}>{children}</DialogContent>
      </Dialog>
    </div>
  );
}

Modal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.element,
  title: PropTypes.string,
  headerText: PropTypes.string,
  className: PropTypes.string,
  maxWidth: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(Modal);
